import AOS from "./modules/aos/aos";

// Defer AOS until after LCP to unblock rendering.
// Loaded as a standalone bundle (excluded from WP Rocket delay-JS) so animations
// reliably initialize without user interaction. The `html.aos-enabled` gate +
// inline bootstrap failsafe (partials/aos-bootstrap.php) guarantee content is
// never left permanently invisible if this script is delayed or fails.
if (window.matchMedia('(min-width: 768px)').matches) {
	const initAOS = () => {
		AOS.init({ disable: "mobile" });

		// Tell the inline bootstrap failsafe that AOS is live, so it leaves the
		// `aos-enabled` class in place instead of revealing everything.
		window.__aosReady = true;

		const onFirstScroll = () => {
			AOS.refresh();
			window.removeEventListener('scroll', onFirstScroll);
		};
		window.addEventListener('scroll', onFirstScroll, { passive: true });

		if ('ResizeObserver' in window) {
			let debounceTimer;
			const ro = new ResizeObserver(() => {
				clearTimeout(debounceTimer);
				debounceTimer = setTimeout(() => AOS.refresh(), 150);
			});
			ro.observe(document.body);
			setTimeout(() => ro.disconnect(), 10000);
		}

		setTimeout(() => AOS.refreshHard(), 1500);
	};

	if (document.readyState === 'complete') {

		'requestIdleCallback' in window
			? requestIdleCallback(initAOS, { timeout: 2000 })
			: initAOS();
	} else {

		window.addEventListener('load', () => {
			'requestIdleCallback' in window
				? requestIdleCallback(initAOS, { timeout: 2000 })
				: setTimeout(initAOS, 100);
		});
	}
}
